import React from 'react';
import { cn } from '../../utils';
import { Box } from 'lucide-react';

interface CollapseLevelMenuProps {
  visible: boolean;
  selectedValue: number;
  onChange: (value: number) => void;
  items: string[];
  title: string;
}

const CollapseLevelMenu: React.FC<CollapseLevelMenuProps> = ({
  visible,
  selectedValue,
  onChange,
  items,
  title,
}) => {
  return (
    <div className="w-full">
      <div className="flex items-center px-2 py-1 font-medium text-sm text-gray-900 border-b border-gray-200 mb-1">
        <span>{title}</span>
      </div>
      {visible && (
        <div className="flex flex-col gap-1.5 w-full">
          {[1, 2, 3, 4].map((level) => (
            <label
              key={`level-${level}`}
              htmlFor={`item-${level}`}
              title={items[level - 1]}
              className={cn(
                'flex items-center w-full px-2 py-1 font-medium rounded-md cursor-pointer',
                'text-xs',
                selectedValue === level
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              )}
            >
              <input
                type="radio"
                id={`item-${level}`}
                name="radio-group"
                checked={selectedValue === level}
                onChange={() => onChange(level)}
                className="mr-2"
              />
              <Box className="w-4 h-4 mr-2" />
              {items[level - 1]}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default CollapseLevelMenu;
